export default {"src":"/_next/static/media/TjLogoCircle.221216b5.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};